import React from "react";
import { Components } from "react-markdown";

import Typography from "../Text";
import css from "./MarkdownReader.module.scss";

export const defaultMarkdownComponentOverrides: Components = {
	a: ({ node, ...props }) => {
		return (
			<a {...props} target="_blank" rel="noopener noreferrer">
				{props.children}
			</a>
		);
	},
	p: ({ node, ...props }) => {
		return (
			<p {...props} className={`text-paragraph-3 font-regular`}>
				{props.children}
			</p>
		);
	},
	h1: ({ node, ...props }) => {
		return (
			<Typography {...props} size="heading-1" weight="bold" color="neutral-10">
				{props.children}
			</Typography>
		);
	},
	h2: ({ node, ...props }) => {
		return (
			<Typography {...props} size="heading-2" weight="bold" color="neutral-10">
				{props.children}
			</Typography>
		);
	},
	h3: ({ node, ...props }) => {
		return (
			<Typography {...props} size="heading-3" weight="bold" color="neutral-10">
				{props.children}
			</Typography>
		);
	},
	ul: ({ node, ...props }) => {
		return (
			<ul {...props} className={css.ul}>
				{props.children}
			</ul>
		);
	},
	ol: ({ node, ...props }) => {
		return (
			<ol {...props} className={css.ol}>
				{props.children}
			</ol>
		);
	},
	li: ({ node, ...props }) => {
		return (
			<Typography element="li" {...props} size="paragraph-3" weight="regular" color="neutral-10">
				{props.children}
			</Typography>
		);
	},
};
